/** @file unpackUpload: the files of a drop or picker, with every zip opened into its PNG entries (fflate). */
import { unzipSync } from 'fflate';
import type { UploadFile } from './artTypes';

const isJunk = (path: string): boolean => path.startsWith('__MACOSX/') || path.includes('/__MACOSX/') || /(^|\/)\.[^/]*$/.test(path);

/** Zip entries as files named by their path; folders and hidden files (`.DS_Store`, `__MACOSX`) are dropped. */
function entriesOf(zip: UploadFile): UploadFile[] {
  return Object.entries(unzipSync(zip.bytes))
    .filter(([path]) => !path.endsWith('/') && !isJunk(path))
    .map(([path, bytes]) => ({ name: path, bytes }));
}

/**
 * `files` read into bytes; a `.zip` becomes its entries. A zip that cannot be read stays one file under its own name,
 * which the plan then reports as skipped.
 */
export async function unpackUpload(files: readonly File[]): Promise<UploadFile[]> {
  const out: UploadFile[] = [];
  for (const f of files) {
    const file = { name: f.name, bytes: new Uint8Array(await f.arrayBuffer()) };
    if (!/\.zip$/i.test(f.name)) { out.push(file); continue; }
    try {
      out.push(...entriesOf(file));
    } catch {
      out.push(file);
    }
  }
  return out;
}
